import React from 'react';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Typography from '@material-ui/core/Typography';
import { useSetupStyles } from './style';

interface OrganizationStepProps {
  control: any;
  errors: any;
}

export default function OrganizationStep({ control, errors }: OrganizationStepProps) {
  const classes = useSetupStyles();

  return (
    <div className={classes.stepContent}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" className={classes.formLabel}>
            Organization Name
          </Typography>
          <Controller
            className={classes.textField}
            variant="outlined"
            name="organizationName"
            control={control}
            rules={{ required: 'Organization Name is required.' }}
            defaultValue=""
            as={
              <OutlinedInput
                placeholder="e.g. Maple Creek Community"
                className={classes.inputStyle}
                labelWidth={0}
              />
            }
          />
          <ErrorMessage
            as={<Typography color="error" />}
            errors={errors}
            name="organizationName"
          />
        </Grid>
      </Grid>
    </div>
  );
}
